import script from "./customImage.vue?vue&type=script&setup=true&lang=js"
export * from "./customImage.vue?vue&type=script&setup=true&lang=js"

import "./customImage.vue?vue&type=style&index=0&id=23f12341&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f12341"]])

export default __exports__